(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/spelpaus/assets/javascripts/init.js') >= 0) return;  svs.modules.push('/modules/spelpaus/assets/javascripts/init.js'); 
(function(Backbone, _, svs) {
  'use strict';

  Marionette.Behaviors.behaviorsLookup = function() {
    return svs.app.behaviors;
  };

  svs.spelpaus.app.start();
})(Backbone, _, svs);

 })(window);